const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BRAND_LOGO = "https://customer-assets.emergentagent.com/job_1818d098-2133-4078-9531-acababa9e2e1/artifacts/6ej2l0dq_fresh%20poboy%20logo%20b.webp";
